import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DpSpReceivingService } from '../../services/raintree/Transmission/dp-sp-receiving.service';

@Component({
  selector: 'app-receiving-dialog',
  standalone: true,
  imports: [],
  templateUrl: './receiving-dialog.component.html',
  styleUrl: './receiving-dialog.component.scss'
})
export class ReceivingDialogComponent {
  @ViewChild('printSection') printSection!: ElementRef;
  isPrintEntered: boolean = false

  constructor(
    public receivingS: DpSpReceivingService,
    public receivDialogRef: MatDialogRef<ReceivingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, details: any, workerName:any, receivingName: string }
  ) { }

  closeDialog(): void {
    this.receivDialogRef.close(); // Close the dialog
  }

  printContent() {
    this.receivingS.print(this.data.message, this.data.details, this.data.workerName, this.data.receivingName)
    this.closeDialog()
  }
}
